
/**
 * @export
 * @enum {string}
 */
export enum ThousandFormat {
    COMMA = 'COMMA',
    SPACE = 'SPACE',
    PERIOD = 'PERIOD',
    QUOTE = 'QUOTE'
}